import React from 'react';
import Inputmask from "inputmask/dist/inputmask/inputmask.date.extensions";

class MaskedText extends React.Component {

    componentDidMount() {
        const { inputmask, displayFormat , onClear} = this.props;
        const element = document.querySelector(".masked-date");
        Inputmask(inputmask, { placeholder: displayFormat, "oncleared": function () {  onClear(""); }}).mask(element);
    }

    focus = () => {
        this.input.focus();
    };

    render() {
        const { alias, inputformat, displayFormat, value, onBlur, onFocus, onChange, onClear,...rest } = this.props; //removing dispayFormat as a prop from dom
        return (
            <input
                value={value}
                ref={el => (this.input = el)}
                data-inputmask-alias={alias}
                data-inputmask-inputformat={inputformat}
                data-im-insert="false"
                className='masked-date'
                onBlur={onBlur}
                onClick={onFocus}
                onChange={onChange}
                {...rest} />
        );
    }
};

MaskedText.defaultProps = {
    inputmask: '99/99/9999',
    alias: 'datetime',
    inputformat: 'mm/dd/yyyy',
    displayFormat: 'MM/DD/YYYY'
};

export default MaskedText;